<template>
  <main class="notification-list">
    <div class="notification-list__container">
      <h1 class="notification-list__title">Уведомления</h1>
      <h3 v-if="isEmpty">В настоящий момент у вас нет уведомлений</h3>
      <template v-else-if="hasNotifications">
        <ul class="notification-list__items">
          <notification-item
            v-for="notification in notifications"
            v-bind:key="notification.id"
            v-bind:notification="notification"
            v-on:notification-view="onView"
          />
        </ul>
        <pagination-page
          class="notification-list__pagination"
          route-name="ClinicPanelNotificationList"
          v-bind:value="page"
          v-bind:page-count="pageCount"
        />
      </template>
    </div>
  </main>
</template>
<script>
import NotificationItem from '@/components/NotificationItem.vue';
import PaginationPage from '@/components/PaginationPage.vue';
import { List } from 'monet';
import { NOTIFICATION_REQUEST } from '@/store/actions/notifications';

/**
 * @description Список уведомлений.
 * @type {any}
 */
export default {
  components: {
    NotificationItem,
    PaginationPage,
  },
  computed: {
    isEmpty() {
      return !this.isAwaitLoadNotificationList && this.notifications.size() === 0;
    },
    hasNotifications() {
      return !this.isAwaitLoadNotificationList && this.notifications.size() > 0;
    },
  },
  created() {
    const page = this.$route.query.page || 1;
    this.fetchNotificationList(page);
  },
  data() {
    return {
      /**
       * Уведомления.
       * @type {List}
       */
      notifications: List(),
      /**
       * Ожидание загрузки списка уведомлений.
       * @type {boolean}
       */
      isAwaitLoadNotificationList: true,
      /**
       * @description Номер текущей страницы.
       * @type {number}
       */
      page: 1,
      /**
       * @description Количество страниц.
       * @type {number}
       */
      pageCount: 1,
    };
  },
  methods: {
    /**
     * @description Получить список уведомлений.
     * @returns {void}
     */
    fetchNotificationList(page) {
      const onResponse = (response) => {
        this.notifications = List.fromArray(response.items);
        this.page = response.page;
        this.pageCount = response.pageCount;
      };
      this.isAwaitLoadNotificationList = true;
      this
        .$notificationGateway
        .viewPage(page)
        .then((result) => result.forEach(onResponse))
        .finally(() => { this.isAwaitLoadNotificationList = false; });
    },
    /**
     * @description Обработать просмотр уведомления.
     * @param {number} id Идентификатор уведомления.
     * @returns {void}
     */
    onView(id) {
      const onSuccess = () => {
        this.notifications = this.notifications.map((candidate) => {
          if (candidate.base.id === id) {
            return candidate.markAsView();
          }
          return candidate;
        });
        this.fetchNewNotificationCount();
      };
      this
        .$notificationGateway
        .markNotificationAsView(id)
        .then((result) => result.fold(this.notifyFailure, onSuccess));
    },
    /**
     * @description Получить количество новых уведомлений.
     * @returns {void}
     */
    fetchNewNotificationCount() {
      const onResponse = (count) => this.$store.commit(NOTIFICATION_REQUEST, { count });
      this
        .$notificationGateway
        .viewNewNotificationCount()
        .then((result) => result.forEach(onResponse));
    },
  },
  name: 'ClinicPanelNotificationList',
};
</script>

<style scoped lang="scss">
.notification-list {
  width: 100%;
  height: 100vh;
  overflow-y: scroll;
  &__container {
    width: 1187px;
    padding: 45px 0 145px 20px;
  }
  &__title {
    color: #000000;
    margin: 0;
  }
  &__items {
    display: grid;
    grid-template-columns: 1fr;
    grid-gap: 10px;
    padding-left: 0;
    margin: 20px 0;
  }
  &__pagination {
    margin: 40px 0 0 0;
  }
}
@media screen and (max-width: 1700px) {
  .notification-list {
    &__container {
      padding: 45px 20px 100px 20px;
    }
  }
}
@media screen and (max-width: 1240px) {
  .notification-list {
    &__container {
      padding: 45px 20px 145px 20px;
      width: 100%;
    }
  }
}
</style>
